import {
  ChangeDetectionStrategy,
  Component,
  Injector,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from "@angular/core";
import { createCustomElement } from "@angular/elements";
import { Store } from "@ngrx/store";
import { BsModalService } from "ngx-bootstrap/modal";
import { Observable } from "rxjs/internal/Observable";
import { ContenteditableDirective } from "../core/content-editable/contenteditable.directive";
import {
  BsModalConfirmComponent,
  createConfirmModalOptions,
} from "../core/modal/modal-confirm.component";
import { PreviewEditTemplateContextComponent } from "./preview-edit-template-context.component";
import { PreviewEditTemplateActions } from "./state/preview-edit-template.actions";
import { ContentEditableService } from '../core/content-editable/contenteditable.service';

@Component({
  selector: "preview-edit-model",
  templateUrl: "./preview-edit-model.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PreviewEditModelComponent implements OnChanges, OnInit {
  @Input() templateParameters;
  @Input() previewEditTemplate;
  @Input() templateUpdateModel;
  @Input() isMappedToOtherUser;
  @Input() selectedUserId;
  @Input() isOnlyPreview;
  @Input() requireVoiceFirstNameTTS;
  @Input() templateId;
  @Input() userPermissions;
  @Input() communicationsCategoryId;
  @Input() activeIndex;

  displayModel: Array<any>;
  selectedTemplateParameter: string;
  displayTemplateParameters = [];
  displayType = "html";
  editable = true;
  isRegistered = false;
  selectedIndex: number;
  text = "";
  isModelEdited = false;
  loading$: Observable<boolean>;
  sortVariables = true;
  allDbValuesEmpty = false;
  modelIsLoading = false;
  missingInModel = [];
  selectedNode: any;
  isMarkAsWarning = false;
  isValueUpdated = false;
  cloneModel: any;
  selection: any;
  mediaType = [ {label: 'All', value: ''},{label: 'email', value: 'email'}, {label: 'sms', value: 'sms'}, {label: 'voice', value: 'voice'}];
  selectedMediaType = undefined;
  voiceTemplateParameters = [];
  selectedVoiceTemplateParameter: string = undefined;
  canAddNew = false;
  isTTS = true;
  isOnlyTTS = false;
  isNotTTSorSound = false;
  isSafari = window.navigator.userAgent.indexOf('safari') === -1;
  // flag to check if we converted comment tag to template-context
  neededToConvert = false;
  constructor(
    public injector: Injector,
    private modalService: BsModalService,
    public contenteditableDirective: ContenteditableDirective,
    private store: Store<any>,
    private contentEditableService: ContentEditableService
  ) {
    // checking if element is already registered
    this.isRegistered =
      document.createElement("template-context").constructor !== HTMLElement;
    if (!this.isRegistered) {
      // Convert `PreviewEditTemplateContextComponents` to a custom element.
      const contextElement = createCustomElement(
        PreviewEditTemplateContextComponent,
        { injector }
      );
      // Register the custom element with the browser.
      customElements.define("template-context", contextElement);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      (changes.previewEditTemplate !== undefined &&
        this.previewEditTemplate !== null &&
        this.previewEditTemplate.model !== undefined) ||
      (changes.templateUpdateModel !== undefined &&
        (changes.templateUpdateModel.previousValue === undefined ||
          this.templateUpdateModel.updateType === "copySourceToDB")) ||
      (changes.templateUpdateModel !== undefined &&
        this.displayType === "raw") ||
      (changes.activeIndex !== undefined && this.activeIndex === 0)
    ) {
      if (!this.isMarkAsWarning) {
        this.displayModel = [];
        const modelMap = { ...this.previewEditTemplate.model };
        const dbMap = { ...this.templateUpdateModel.updatedModel };
        this.allDbValuesEmpty = true;

        const modelKeyArray = Object.keys(modelMap);
        modelKeyArray.map((key) => {
          const modelKey =
            key.indexOf("template") !== -1 ? key.split(".")[1] : key;
          let dbValue = dbMap[modelKey];
            dbValue = dbValue === undefined  ? modelKey.indexOf('DateFormat') !== -1 ? "" : " " : dbValue;
          let markAsWarning = this.contentEditableService.validateTemplateOnBlur(modelKey, dbMap).markAsWarning;
          const fileValue = modelMap[key] || "";
          if (key.indexOf("template") !== -1) {
            this.displayModel.push({
              name: modelKey,
              content: fileValue,
              rawDefaultContent: dbValue,
              markAsWarning: markAsWarning,
            });
          }
          // this.unsortedDisplayModel.push({name: key, content: modelMap[key], rawDefaultContent: value});

          if (dbValue !== "") {
            this.allDbValuesEmpty = false;
          }
        });

        // Check for missing key
        Object.keys(dbMap).map((key) => {
          if (
            modelKeyArray.findIndex(
              (modelKey) =>
                (modelKey.indexOf("template") !== -1
                  ? modelKey.split(".")[1]
                  : modelKey) === key
            ) === -1
          ) {
            this.missingInModel.push(key);
            const dbValue = dbMap[key];
            let markAsWarning = this.contentEditableService.validateTemplateOnBlur(key, dbMap).markAsWarning;
            this.displayModel.push({
              name: key,
              content: undefined,
              rawDefaultContent: dbValue,
              markAsWarning,
            });
          }
        });
      } else {
        this.isMarkAsWarning = false;
      }
    }

    if (changes.templateParameters !== undefined) {
      if (
        this.templateParameters !== [] &&
        this.templateParameters.length !== 0
      ) {
        this.displayTemplateParameters = [...this.templateParameters];
        if (
          this.communicationsCategoryId === "reminder" ||
          this.communicationsCategoryId === "birthday" ||
          this.communicationsCategoryId === "newsletter" ||
          this.communicationsCategoryId === "seasonal" ||
          this.communicationsCategoryId === "survey" ||
          this.communicationsCategoryId === "review" ||
          this.communicationsCategoryId === "sale"
        ) {
          const locationIndex = this.displayTemplateParameters.findIndex(
            (templateParameter) => templateParameter.label === "location"
          );
          this.displayTemplateParameters.splice(locationIndex, 4);
        }
        this.selectedTemplateParameter = this.templateParameters[0].value;
      }
    }
  }

  onDisplayTypeChange(val): void {
    this.displayType = val;
    this.editable = this.displayType !== "raw";
    if (val === "raw") {
      this.cloneModel = { ...this.templateUpdateModel.updatedModel };
    }
  }

  setSelectedData(modelName): void {
      this.selection = {
          focusOffset: window.getSelection().focusOffset,
          focusNode: window.getSelection().focusNode,
      };
      this.validateTemplateOnBlur(modelName, this.templateUpdateModel.updatedModel);
  }

  getUpdatedDBModel(updatedModel): any {
    const cloneModel = {};
    updatedModel.forEach((model) => {
      cloneModel[model[0]] = model[1];
    });

    return cloneModel;
  }

  setSelectedIndex(event, selectedKey): void {
    this.selectedNode = event.target;
    while (this.selectedNode.id === "") {
      this.selectedNode = this.selectedNode.parentNode;
    }

    this.selectedIndex = 0;
    // in case we add new entry in source, to handle exception we add the same key in model as well.
    const dbModel = { ...this.templateUpdateModel.updatedModel };
    if (
      Object.keys(this.templateUpdateModel.updatedModel).findIndex(
        (key) => key === selectedKey
      ) === -1
    ) {
      dbModel[selectedKey] = "";
      const templateUpdateModel = {
        updatedModel: dbModel,
        isModelUpdated: true,
        updateType: "model",
          type: ""
      };
      this.store.dispatch(
        PreviewEditTemplateActions.templateUpdateModel({ templateUpdateModel })
      );
    }
    // this is needed to enable cursor to  be displayed after template-context when last child
    if (
      this.selectedNode.lastChild !== undefined &&
      this.selectedNode.lastChild !== null &&
      this.selectedNode.lastChild.localName !== undefined &&
      this.selectedNode.lastChild.localName === "template-context"
    ) {
      const textnode = document.createTextNode(""); // Create a text node
      this.selectedNode.appendChild(textnode);
    }
  }

  ngOnInit(): void {
    this.cloneModel = { ...this.templateUpdateModel.updatedModel };
    this.setVoiceTemplateParameters();
    this.selectedVoiceTemplateParameter = this.voiceTemplateParameters[0].value;
    this.onlyTTS();
    this.selectedMediaType = sessionStorage.length > 0 && sessionStorage.getItem('selectedMediaType') !== null
                                ?  sessionStorage.getItem('selectedMediaType') : 'all';
  }

  onBlur(event, val, modelName): void {
    // console.log('------model blur ----- ', val, '------------', this.isValueUpdated);
    this.preprocessModel();
    if (this.displayType === "raw" && this.isValueUpdated) {
      const templateUpdateModel = {
        updatedModel: this.cloneModel,
        isModelUpdated: true,
        updateType: "model",
          type: ""
      };
      this.store.dispatch(
        PreviewEditTemplateActions.templateUpdateModel({ templateUpdateModel })
      );
      this.isValueUpdated = false;
      this.validateTemplateOnBlur(modelName, this.cloneModel);
    }
  }

  /**
   * Delete field from DB model (user must take action to save changes)
   */
  removeVariableFromModelAction(rowIndex, updatedModel): void {
    this.isModelEdited = true;
    const deletedRowName = this.displayModel[rowIndex].name;
    this.displayModel.splice(rowIndex, 1);
    const updatedModelAfterRemove = {...updatedModel};
    delete updatedModelAfterRemove[deletedRowName];
    const templateUpdateModel = {
      updatedModel: this.getUpdatedDBModel(Object.entries(updatedModelAfterRemove)),
      isModelUpdated: true,
      updateType: "model",
      type: ""
    };
    this.store.dispatch(
      PreviewEditTemplateActions.templateUpdateModel({ templateUpdateModel })
    );

    // check if we are removing voice template parameter
    this.voiceTemplateParameters.find(voiceTemplate => {
        if (deletedRowName.indexOf(voiceTemplate.value) !== -1) {
            voiceTemplate.isAlreadyMapped = false;
        }
    })
  }

  setToDbModel(rowIndex, content, updatedModel): void {
    this.displayModel[rowIndex].rawDefaultContent = content;
    const selectedRowName = this.displayModel[rowIndex].name;
    const updatedModelAfter = {...updatedModel};
    updatedModelAfter[selectedRowName] = content;
    this.isModelEdited = true;
    this.updateTemplateModel(this.getUpdatedDBModel(Object.entries(updatedModelAfter)), true, "copySourceToDB", "");
  }

  isMissingInSource(name): boolean {
    return this.missingInModel.findIndex((key) => key === name) !== -1;
  }

  copyFieldsFromSourceToDBDialog(event, updatedModel): void {
    if (this.allDbValuesEmpty) {
      console.log(
        "All DB values are empty. Just copying fields from Source to DB."
      );
      const inFileModel = { ...this.previewEditTemplate.model };
      // this.modelChange.emit(inFileModel);
        this.updateTemplateModel(inFileModel, true, "model", "");
    } else {
      if (this.isContentDifferent()) {
        const modalRef = this.modalService.show(
          BsModalConfirmComponent,
          createConfirmModalOptions(
            "Confirm overwriting fields of database model",
            "Some variables already have different values. Are you sure you want to replace with model from the template file?",
            "Yes",
            "No"
          )
        );

        modalRef.content.onClose.subscribe((dialogResult) => {
          if (dialogResult.isConfirmed) {
            const inFileModel = {};
            this.updateDbModelFromFile(inFileModel);
            this.updateTemplateModel(inFileModel, true, "copySourceToDB", "");
          } else {
            this.highlightDifference();
            this.updateTemplateModel(this.getUpdatedDBModel(Object.entries(updatedModel)), true, "model", "");
          }
        });
      } else {
        const inFileModel = {};
        this.updateDbModelFromFile(inFileModel);
        this.updateTemplateModel(inFileModel, true, "model", "");
      }
    }
  }

  updateTemplateModel(updatedModel: any , isModelUpdated: boolean, updateType: string, type: string) : void {
      const templateUpdateModel = {
          updatedModel,
          isModelUpdated,
          updateType,
          type
      };
      this.store.dispatch(
          PreviewEditTemplateActions.templateUpdateModel({
              templateUpdateModel,
          })
      );
    }

  updateDbModelFromFile(inFileModel): any {
    const model = { ...this.previewEditTemplate.model };
    Object.keys(model)
       .map(key => {
      const modelKey = key.indexOf('template') !== -1 ? key.split('.')[1] : key;
      const modelValue = model[key] || '';
      inFileModel[modelKey] = modelValue;
    });
  }

  isContentDifferent(): boolean {
    return (
      this.displayModel.findIndex(
        (model) => model.content !== this.templateUpdateModel.updatedModel[model.name]
      ) !== -1
    );
  }

  highlightDifference(): void {
    this.isMarkAsWarning = true;
    this.displayModel.map((model) => {
      if (model.content !== this.templateUpdateModel.updatedModel[model.name]) {
        model.markAsWarning = true;
      }

      return model;
    });
  }

  modelUpdated(event, key): any {
    this.isValueUpdated = true;
    this.cloneModel = { ...this.templateUpdateModel.updatedModel };
    // Validate here

    this.cloneModel[key] = event;
  }

    validateTemplateOnBlur(modelName, updatedModel): void {
      let errorMsg = '';
      if (modelName.indexOf("DateFormat") !== -1) {
          errorMsg = "The date format contains incorrect value. Either remove the blank space or enter correct date format.";
      }
      else if (modelName.indexOf("voice") !== -1) {
          errorMsg = "The added Sound variable " + modelName +" can take either Numbers or template-parameter as value."
      }
      else if (modelName.toLowerCase().indexOf('color') !== -1 || modelName.toLowerCase().indexOf('logo') !== -1
          || modelName.toLowerCase().indexOf('image') !== -1) {
          errorMsg = "The variable " + modelName +" contains invalid value, please correct it (in RAW) so template can parse correctly."
      } else if (modelName.toLowerCase().indexOf('emailsubject') !== -1) {
          errorMsg = "Email Subject" + modelName +" contains style, please correct it (in RAW) so template can parse correctly."
      } else {
          errorMsg = "The variable " + modelName +" contains invalid Variable value (example: <span class=\"label2 label-info\"> or missing closing img tag), please try to remove and add the Variable again to get the correct value."
      }

      let markAsWarning: boolean = this.contentEditableService.validateTemplateOnBlur(modelName, updatedModel).markAsWarning;

      this.displayModel.find(model => {
          if (model.name === modelName) {
              if (markAsWarning) {
                  this.store.dispatch(PreviewEditTemplateActions.displayDialogOnError({error: errorMsg}));
              }
              return model.markAsWarning = markAsWarning;
          }
      });

  }

  preprocessModel(): void {
    const dbModelWithoutContentEditable = {};
    Object.entries(this.templateUpdateModel.updatedModel).map((tData) => {
      if (tData[1] !== "") {
        let value: any = tData[1].toString();
        value = value.replaceAll('contenteditable="false">', ">");
        dbModelWithoutContentEditable[tData[0]] = value;
      }

      return tData;
    });

    if (this.templateId !== undefined) {
      this.store.dispatch(
        PreviewEditTemplateActions.preprocessModel({
          mediaType: 'email',
          template: dbModelWithoutContentEditable,
          templateId: this.templateId,
          selectedUserId: this.selectedUserId
        })
      );
    }
  }

  setVoiceTemplateParameters(): void {
      this.voiceTemplateParameters = [
          {label: '-- Select --', value: '', isAlreadyMapped: true},
          {label: 'api_autoConfirmVoicemail (Auto Confirm Voicemail)', value: 'voiceApiAutoConfirmVoicemail', isAlreadyMapped: false},
          {label: 'contactPhone (Caller ID)', value: 'voiceContactPhone', isAlreadyMapped: false},
          {label: 'companyIntro (WHO_INTRO)', value: 'voiceCompanyIntro', isAlreadyMapped: false},
          {label: 'companyIntroConfirm (WHO_CONFIRM)', value: 'voiceCompanyIntroConfirm', isAlreadyMapped: false},
          {label: 'companyIntro2 (WHO_INTRO 2)', value: 'voiceCompanyIntro2' , isAlreadyMapped: false},
          {label: 'to (PROFILEINTRO)', value: 'voiceTo' , isAlreadyMapped: false},
          {label: 'regarding (APPOINTMENT)', value: 'voiceRegarding' , isAlreadyMapped: false},
          {label: 'regardingConfirm (APPOINTMENTC)', value: 'voiceRegardingConfirm' , isAlreadyMapped: false},
          {label: 'regarding2 (APPOINTMENT2)', value: 'voiceRegarding2' , isAlreadyMapped: false},
          {label: 'regardingVoicemail (APPOINTMENT)', value: 'voiceRegardingVoicemail' , isAlreadyMapped: false},
          {label: 'regardingVoicemail2 (APPOINTMENT2)', value: 'voiceRegardingVoicemail2' , isAlreadyMapped: false},
          {label: 'location (Location)', value: 'voiceLocation' , isAlreadyMapped: false},
          {label: 'location2 (Location)', value: 'voiceLocation2', isAlreadyMapped: false},
          {label: 'instruction (RESCHEDULE)', value: 'voiceInstruction' , isAlreadyMapped: false},
          {label: 'instruction2 (RESCHEDULE2)', value: 'voiceInstruction2', isAlreadyMapped: false},
          {label: 'instructionVoicemail (RESCHEDULE)', value: 'voiceInstructionVoicemail', isAlreadyMapped: false },
          {label: 'instructionVoicemail 2 (RESCHEDULE2)', value: 'voiceInstructionVoicemail2', isAlreadyMapped: false},
          {label: 'press1repeat (TRYK1)', value: 'voicepress1repeat', isAlreadyMapped: false},
          {label: 'press5confirm (TRYK5_TOCONFIRM)', value: 'voicepress5confirm', isAlreadyMapped: false},
          {label: 'goodbye (GENSYN)', value: 'voiceGoodbye', isAlreadyMapped: false},
          {label: 'companyOutro (WHO_OUTRO)', value: 'voiceCompanyOutro' , isAlreadyMapped: false}
      ];

      // if template parameter is already part of Source, mark it disabled so we cannot re-map
      Object.entries(this.cloneModel)
         .map(model => {
            const key = model[0]
               .replace('TTS', '')
               .replace('Sound', '');
            if (key.indexOf('voice') !== -1) {
               this.voiceTemplateParameters.find(voiceTemplate => {
                  if (key ===  voiceTemplate.value) {
                     voiceTemplate.isAlreadyMapped = true;
                  }
               });
            }
         });
  }

  onlyTTS(): void {
      this.isNotTTSorSound = this.selectedVoiceTemplateParameter.indexOf('voiceApiAutoConfirmVoicemail') !== -1 ||
         this.selectedVoiceTemplateParameter.indexOf('voiceContactPhone') !== -1;
      // this.isOnlyTTS = this.selectedVoiceTemplateParameter.indexOf('voiceContactPhone') !== -1;
      // this.isTTS = this.isOnlyTTS ? true : false;
      this.canAddNew = this.selectedVoiceTemplateParameter !== '';
  }

  addVoiceVariable(updatedModel): void {
      const name = this.isOnlyTTS ||  this.isNotTTSorSound
         ? this.selectedVoiceTemplateParameter
         : this.selectedVoiceTemplateParameter + (this.isTTS ? 'TTS' : 'Sound');

      let validateIfExists = false;
      Object.entries(updatedModel).map(model => {
          const key = model[0]
              .replace('TTS', '')
              .replace('Sound', '');
          if (key.indexOf('voice') !== -1) {
              if (key === this.selectedVoiceTemplateParameter) {
                  validateIfExists = true;
              }
          }
      });

      if (!validateIfExists) {
          const defaultBlankRow = {
              name,
              content: undefined,
              rawDefaultContent: '',
              markAsWarning: false
          };
          this.displayModel.push(defaultBlankRow);
          const updatedModelAfter = {...updatedModel};
          updatedModelAfter[name] = '';
          this.missingInModel.push(name);
          this.updateTemplateModel(this.getUpdatedDBModel(Object.entries(updatedModelAfter)), true, 'model', '');
          this.voiceTemplateParameters.find(voiceTemplate => {
              if (voiceTemplate.value !== '' && voiceTemplate.value === this.selectedVoiceTemplateParameter) {
                  voiceTemplate.isAlreadyMapped = true;
              }
          });
          this.selectedVoiceTemplateParameter = this.voiceTemplateParameters[0].value;
          this.canAddNew = false;
      }
  }

  ttsOrSound(): void {
      this.isTTS = this.isOnlyTTS ? true : !this.isTTS;
  }

  mediaTypeChanged(): void {
      sessionStorage.setItem('selectedMediaType', this.selectedMediaType);
  }
}
